"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const lodash_1 = require("lodash");
const react_1 = require("react");
const react_router_1 = require("react-router");
const appConstants_1 = require("../../../../constants/appConstants");
const StyledBox_1 = require("../../../../material-ui-theme/components/styled/StyledBox");
const settlementQuery_1 = require("../../../../queries/settlementQuery");
const zustandStore_1 = require("../../../../zustandStore");
const helpers_1 = __importDefault(require("../helpers"));
const lexico = new lexico_1.default();
const StyledFormLabel = (0, material_1.styled)(material_1.FormLabel)(() => ({
    lineHeight: '10px',
    fontWeight: '600',
    fontSize: '12px',
    marginBottom: '10px',
}));
const ALL_SOURCE_CARDS = {
    label: lexico.trc('Option select title', 'All cards'),
    id: 'allSourceCards',
};
const ALL_VIRTUAL_CARDS = {
    label: lexico.trc('Option select title', 'All virtual cards'),
    id: 'allVirtualCards',
};
const date = new Date();
const SettlementsHeaderActions = () => {
    const currentYear = date.getFullYear();
    const initialData = (0, react_router_1.useLoaderData)();
    const { filters, setSettlementFilters, options, setSettlementOptions, setSettlements, setPage, resetSettlementFilters, areSettlementFiltersManuallySet, setAreSettlementFiltersManuallySet, isReceiptUploadRemove, setIsReceiptUploadRemove, } = (0, zustandStore_1.useZustand)(state => ({
        filters: state.settlement.filters,
        setSettlementFilters: state.setSettlementFilters,
        options: state.settlement.options,
        setSettlementOptions: state.setSettlementOptions,
        setSettlements: state.setSettlements,
        setPage: state.setPage,
        resetSettlementFilters: state.resetSettlementFilters,
        areSettlementFiltersManuallySet: state.settlement.areSettlementFiltersManuallySet,
        setAreSettlementFiltersManuallySet: state.setAreSettlementFiltersManuallySet,
        isReceiptUploadRemove: state.settlement.isReceiptUploadRemove,
        setIsReceiptUploadRemove: state.setIsReceiptUploadRemove,
    }));
    const query = {
        ...(0, settlementQuery_1.getSettlementListQuery)({
            month: filters.month,
            year: filters.year,
            teamId: initialData.teamId,
        }),
        initialData: initialData.settlements,
    };
    const { data: settlements } = (0, react_query_1.useQuery)(query);
    (0, react_1.useEffect)(() => {
        if (filters.parentCard === 'allSourceCards' &&
            filters.virtualCard === 'allVirtualCards' &&
            !filters.showTransactionWithoutReceipts) {
            setSettlements(settlements);
        }
    }, [settlements]);
    (0, react_1.useEffect)(() => {
        const pCards = helpers_1.default.getSourceCards(settlements);
        const vCards = helpers_1.default.getVirtualCards(settlements);
        setSettlementOptions({
            ...options,
            parentCards: [ALL_SOURCE_CARDS, ...pCards],
            virtualCards: [ALL_VIRTUAL_CARDS, ...vCards],
            months: appConstants_1.months,
            years: (0, lodash_1.range)(2015, currentYear + 1),
        });
    }, [settlements, settlements.length]);
    (0, react_1.useEffect)(() => {
        if (!areSettlementFiltersManuallySet) {
            resetSettlementFilters();
        }
        setAreSettlementFiltersManuallySet(false);
    }, []);
    const setFilters = () => {
        if (filters.virtualCard !== 'allVirtualCards' && filters.parentCard !== 'allSourceCards') {
            setSettlements(settlements.filter(settlement => settlement.cardSource.id === filters.parentCard && settlement.cardId === filters.virtualCard));
        }
        else if (filters.virtualCard !== 'allVirtualCards') {
            setSettlements(settlements.filter(settlement => settlement.cardId === filters.virtualCard));
        }
        else if (filters.parentCard === 'allSourceCards') {
            setSettlements(settlements);
        }
        else {
            setSettlements(settlements.filter(settlement => settlement.cardSource.id === filters.parentCard));
        }
    };
    const handleToggle = (0, react_1.useCallback)((_event, checked) => {
        setSettlementFilters({ ...filters, showTransactionWithoutReceipts: checked });
    }, [setSettlementFilters, filters]);
    (0, react_1.useEffect)(() => {
        if (filters.showTransactionWithoutReceipts) {
            if (filters.virtualCard !== 'allVirtualCards' && filters.parentCard !== 'allSourceCards') {
                setSettlements(settlements.filter(settlement => settlement.cardId === filters.virtualCard &&
                    settlement.cardSource.id === filters.parentCard &&
                    !settlement.receiptId));
            }
            else if (filters.parentCard !== 'allSourceCards') {
                setSettlements(settlements.filter(settlement => settlement.cardSource.id === filters.parentCard && !settlement.receiptId));
            }
            else if (filters.virtualCard === 'allVirtualCards') {
                setSettlements(settlements.filter(settlement => !settlement.receiptId));
            }
            else {
                setSettlements(settlements.filter(settlement => settlement.cardId === filters.virtualCard && !settlement.receiptId));
            }
        }
        else {
            setFilters();
        }
        setPage(1);
        setIsReceiptUploadRemove(false);
    }, [
        filters.showTransactionWithoutReceipts,
        isReceiptUploadRemove,
        filters.virtualCard,
        filters.parentCard,
        settlements,
    ]);
    return ((0, jsx_runtime_1.jsxs)(StyledBox_1.StyledSettlementHeaderBox, { "data-testid": "settlement-header-actions", children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { "data-testid": "pcard-filter", sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    p: 1,
                }, children: [(0, jsx_runtime_1.jsx)(StyledFormLabel, { style: {
                            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? {
                                    fontWeight: 400,
                                    textTransform: 'none',
                                }
                                : {}),
                        }, children: (globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'Physical' : 'Parent') + ' card' }), (0, jsx_runtime_1.jsx)(material_1.Select, { "data-testid": "parent-card-filter", value: filters.parentCard, onChange: event => {
                            setSettlementFilters({ ...filters, parentCard: event.target.value, virtualCard: 'allVirtualCards' });
                            setAreSettlementFiltersManuallySet(true);
                        }, label: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'PHYSICAL CARD' : 'PARENT CARD', sx: [
                            {
                                minWidth: 150,
                                maxWidth: 150,
                            },
                            globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? {
                                    fontWeight: 400,
                                    textTransform: 'none',
                                }
                                : {},
                        ], required: true, children: options?.parentCards?.map(type => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: type.id, style: {
                                ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                    ? {
                                        fontWeight: 400,
                                        textTransform: 'none',
                                    }
                                    : {}),
                            }, children: type.label }, type.id))) }, "parentCard")] }), (0, jsx_runtime_1.jsxs)(material_1.Box, { "data-testid": "vcard-filter", sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    p: 1,
                }, children: [(0, jsx_runtime_1.jsx)(StyledFormLabel, { style: {
                            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? {
                                    fontWeight: 400,
                                    textTransform: 'none',
                                }
                                : {}),
                        }, children: "Virtual card" }), (0, jsx_runtime_1.jsx)(material_1.Select, { label: "VIRTUAL CARD", "data-testid": "virtual-card-filter", value: filters.virtualCard, onChange: event => {
                            setSettlementFilters({ ...filters, virtualCard: event.target.value });
                            setAreSettlementFiltersManuallySet(true);
                        }, sx: [
                            {
                                minWidth: 150,
                                maxWidth: 150,
                            },
                            globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? {
                                    fontWeight: 400,
                                    textTransform: 'none',
                                }
                                : {},
                        ], required: true, children: options?.virtualCards?.map(type => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: type.id, style: {
                                ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                    ? {
                                        fontWeight: 400,
                                        textTransform: 'none',
                                    }
                                    : {}),
                            }, children: type.label }, type.id))) }, "virtualCard")] }), (0, jsx_runtime_1.jsxs)(material_1.Box, { "data-testid": "month-filter", sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    p: 1,
                }, children: [(0, jsx_runtime_1.jsx)(StyledFormLabel, { style: {
                            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? {
                                    fontWeight: 400,
                                    textTransform: 'none',
                                }
                                : {}),
                        }, children: "Month" }), (0, jsx_runtime_1.jsx)(material_1.Select, { "data-testid": "month-filter", value: filters.month, onChange: event => {
                            setSettlementFilters({
                                ...filters,
                                month: event.target.value,
                                parentCard: 'allSourceCards',
                                virtualCard: 'allVirtualCards',
                                showTransactionWithoutReceipts: false,
                            });
                            setAreSettlementFiltersManuallySet(true);
                        }, sx: [
                            {
                                minWidth: 150,
                            },
                            globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? {
                                    fontWeight: 400,
                                    textTransform: 'none',
                                }
                                : {},
                        ], required: true, children: options?.months?.map(type => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: type?.value, style: {
                                ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                    ? {
                                        fontWeight: 400,
                                        textTransform: 'none',
                                    }
                                    : {}),
                            }, children: type?.name }, type?.name))) }, "month")] }), (0, jsx_runtime_1.jsxs)(material_1.Box, { "data-testid": "year-filter", sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    p: 1,
                }, children: [(0, jsx_runtime_1.jsx)(StyledFormLabel, { style: {
                            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? {
                                    fontWeight: 400,
                                    textTransform: 'none',
                                }
                                : {}),
                        }, children: "Year" }), (0, jsx_runtime_1.jsx)(material_1.Select, { "data-testid": "year-filter", value: filters.year, onChange: event => {
                            setSettlementFilters({
                                ...filters,
                                year: event.target.value,
                                parentCard: 'allSourceCards',
                                virtualCard: 'allVirtualCards',
                                showTransactionWithoutReceipts: false,
                            });
                            setAreSettlementFiltersManuallySet(true);
                        }, sx: [
                            {
                                minWidth: 150,
                            },
                            globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? {
                                    fontWeight: 400,
                                    textTransform: 'none',
                                }
                                : {},
                        ], required: true, children: options?.years?.map(type => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: type, style: {
                                ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                    ? {
                                        fontWeight: 400,
                                        textTransform: 'none',
                                    }
                                    : {}),
                            }, children: type }, type))) }, "year")] }), (0, jsx_runtime_1.jsxs)(material_1.Box, { "data-testid": "toggle-filter", sx: {
                    display: 'flex',
                    flexDirection: 'column',
                }, children: [(0, jsx_runtime_1.jsx)("br", {}), initialData.showReceiptUpload ? ((0, jsx_runtime_1.jsx)(material_1.FormGroup, { sx: { p: 0 }, children: (0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { name: 'show-transaction-receipt', control: (0, jsx_runtime_1.jsx)(material_1.Switch, { color: "primary", checked: Boolean(filters?.showTransactionWithoutReceipts), onChange: (event, checked) => handleToggle(event, checked) }), label: lexico.trc('Show receipt toggle switch', 'Show transactions without receipts'), labelPlacement: "start" }) })) : null] })] }));
};
exports.default = SettlementsHeaderActions;
